export class LocalDbMessages {
  constructor(db) {
    this.db = db;
  }

  getMessageId(messageKey) {
    let transaction = this.db.transaction("messages", "readwrite");
    let messages = transaction.objectStore("messages");
    let keyIndex = messages.index("key_idx");
    let request = keyIndex.get(messageKey);
    return new Promise(function (resolve, reject) {
      request.onerror = function () {
        reject(new Error("Database getMessage() error"));
      };
      request.onsuccess = function () {
        resolve(request.result?.id);
      };
    });
  }

  async addMessage(message) {
    // console.log("ADD", message.text, message);

    await new Promise((resolve) => setTimeout(() => resolve(), 10));

    if (!message.id) {
      let id = await this.getMessageId(message.key);
      if (id) message.id = id;
      else delete message.id;
    }

    let transaction = this.db.transaction("messages", "readwrite");
    let messages = transaction.objectStore("messages");
    let request = messages.put(
      // костыль, так как нельзя сохранять объекты, которые внутри имеют ссылки
      JSON.parse(JSON.stringify(message))
    );
    let _this = this;
    return new Promise(function (resolve, reject) {
      request.onerror = function () {
        // console.log("ERROR", message.text);
        // reject(new Error("Database addMessage() error"));
        resolve(_this.getMessageId(message.key));
      };
      request.onsuccess = function () {
        resolve(request.result);
      };
    });
  }

  getMessages(messageId = 0, duration = "prev", count = 20) {
    // // // duration = prev | next // // //
    let transaction = this.db.transaction("messages");
    let messages = transaction.objectStore("messages");
    let request = messages.getAllKeys();

    return new Promise(function (resolve, reject) {
      request.onerror = function () {
        reject(new Error("Database getAllKeys() error"));
      };
      request.onsuccess = function () {
        // console.log("allKeys", request.result);
        let allKeys = request.result;
        if (!allKeys || !allKeys.length) {
          resolve([]);
        } else {
          let from = 0;
          let to = allKeys.length - 1;
          if (messageId == 0) {
            if (duration == "next" && allKeys.length > count) {
              to = count - 1;
            }
            if (duration == "prev" && allKeys.length > count) {
              from = allKeys.length - count;
            }
          } else {
            let messageIdIndex = allKeys.indexOf(messageId);
            if (
              messageIdIndex == -1 ||
              (duration == "next" && messageIdIndex + 1 == allKeys.length) ||
              (duration == "prev" && messageIdIndex == 0)
            ) {
              resolve([]);
            } else {
              if (duration == "next") {
                from = messageIdIndex + 1;
                to = messageIdIndex + count < to ? messageIdIndex + count : to;
              }
              if (duration == "prev") {
                from = messageIdIndex - count < 0 ? 0 : messageIdIndex - count;
                to = messageIdIndex - 1;
              }
            }
          }
          // console.log("from ", from, "to ", to);
          let request2 = messages.getAll(
            IDBKeyRange.bound(allKeys[from], allKeys[to])
          );
          request2.onerror = function () {
            reject(new Error("Database getAll() error"));
          };
          request2.onsuccess = function () {
            // console.log("result", request2.result);
            resolve(request2.result);
          };
        }
      };
    });
  }

  updateMessage(message) {
    let transaction = this.db.transaction("messages", "readwrite");
    let messages = transaction.objectStore("messages");
    let request = messages.put(
      // костыль, так как нельзя сохранять объекты, которые внутри имеют ссылки
      JSON.parse(JSON.stringify(message))
    );

    return new Promise(function (resolve, reject) {
      request.onerror = function () {
        reject(new Error("Database updateMessage() error"));
      };
      request.onsuccess = function () {
        resolve(request.result);
      };
    });
  }

  clearMessages() {
    let transaction = this.db.transaction("messages", "readwrite");
    let messages = transaction.objectStore("messages");
    let request = messages.clear();
    return new Promise(function (resolve, reject) {
      request.onerror = function () {
        reject(new Error("Database clearMessages() error"));
      };
      request.onsuccess = function () {
        resolve(request.result);
      };
    });
  }

  search(text) {
    let transaction = this.db.transaction("messages", "readwrite");
    let messages = transaction.objectStore("messages");
    let request = messages.openCursor();
    return new Promise(function (resolve, reject) {
      let result = [];
      request.onerror = function () {
        reject(new Error("Database clearMessages() error"));
      };
      request.onsuccess = function (event) {
        let cursor = event.target.result;
        if (cursor) {
          if (
            cursor.value.text &&
            cursor.value.text.toLowerCase().indexOf(text.toLowerCase()) !== -1
          ) {
            result.push(cursor.value);
          }
          cursor.continue();
        } else {
          resolve(result);
        }
      };
    });
  }
}
